import { normalSanatizerBRL } from "src/utils/functions";
import { ResultCalculoFGTS } from "../calcular-fgts";
export const CalculadoraFGTSTable = ({
    results
}: {
    results: ResultCalculoFGTS
}) => {
    return (
        <div className="max-h-[400px] overflow-y-auto m-auto overflow-x-auto">
            <table className="bg-white rounded w-full max-h-[400px] overflow-y-auto">
                <thead className="bg-gray-200 sticky top-0">
                    <tr>
                        <th className="px-4 py-2 text-center truncate">Evento</th>
                        <th className="px-4 py-2 text-center truncate">Valores</th>
                    </tr>
                </thead>
                <tbody>
                    <tr className=" border-b">
                        <td className="px-4 py-2 text-center truncate border-r">
                            Deposito Mensal
                        </td>
                        <td className="px-4 py-2 text-center truncate border-r">
                            R$ {normalSanatizerBRL(results.depositomensal)}
                        </td>
                    </tr>
                    <tr className=" border-b">
                        <td className="px-4 py-2 text-center truncate border-r">
                            Meses de contribuição
                        </td>
                        <td className="px-4 py-2 text-center truncate border-r">
                            {results.meses}
                        </td>
                    </tr>
                    <tr className=" border-b">
                        <td className="px-4 py-2 text-center truncate border-r">
                            Déposito total
                        </td>
                        <td className="px-4 py-2 text-center truncate border-r">
                            R$ {normalSanatizerBRL(results.depositoTotal)}
                        </td>
                    </tr>
                    <tr className=" border-b">
                        <td className="px-4 py-2 text-center truncate border-r">
                            Saldo final
                        </td>
                        <td className="px-4 py-2 text-center truncate border-r">
                            R$ {normalSanatizerBRL(results.valorFinal)}
                        </td>
                    </tr>
                    {results.saldoCorrigido > 0 ? <tr className=" border-b">
                        <td className="px-4 py-2 text-center truncate border-r">
                            Saldo com correção de juros
                        </td>
                        <td className="px-4 py-2 text-center truncate border-r">
                            R$ {normalSanatizerBRL(results.saldoCorrigido)}
                        </td>
                    </tr> :
                        null
                    }

                </tbody>
            </table>

        </div >
    )
}